<template>
    <footer>
      <p>© 2025 лаборатория-физики</p>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent',
  };
  </script>
  